/**
 * Componente que se encarga de recibir las peticiones enviadas desde los diferentes componentes
 * en el momento de crear, editar o eliminar los registros.  Esto con el fin de que se 
 * recarguen los datos de las tablas afectadas por las datatables.
 * JMM-2018-04-25
 */

//Componente
import { Component, OnInit } from '@angular/core';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-enrutamiento',
  templateUrl: './enrutamiento.component.html'
})
export class EnrutamientoComponent implements OnInit {

  constructor(
    private route   : ActivatedRoute,
    private router  : Router,
    private http    : Http
  ) {}

  /**
   * Dentro de esta función se manejan los enrutamientos automáticos
   * hacia donde se enrutan las peticiones de cada componente.
   * JMM-2018-04-24
   */
  ngOnInit() 
  {
    let identificador = this.route.snapshot.paramMap.get('id');

    if (identificador == 'marcas') {
      this.router.navigate(['/main/marcas', 'modMarcas'], { replaceUrl: true });
    }

    if (identificador == 'usuarios') {
      this.router.navigate(['/main/usuarios'], { replaceUrl: true });
    }

    if (identificador == 'dependencias') {
      this.router.navigate(['/main/dependencias'], { replaceUrl: true });
    }

    if (identificador == 'zonas') {
      this.router.navigate(['/main/zonas'], { replaceUrl: true });
    }

    if (identificador == 'centcost') {
      this.router.navigate(['/main/centcost'], { replaceUrl: true });
    }

    if (identificador == 'profesiones') {
      this.router.navigate(['/main/profesiones'], { replaceUrl: true });
    }

    if (identificador == 'tipoterceros') {
      this.router.navigate(['/main/tipoterceros'], { replaceUrl: true });
    }

    if (identificador == 'modelos') {
      this.router.navigate(['/main/modelos'], { replaceUrl: true });
    }

    if (identificador == 'familias') {
      this.router.navigate(['/main/familias', 'modFamilias'], { replaceUrl: true });
    }

    if (identificador == 'equipos') {
      this.router.navigate(['/main/equipos'], { replaceUrl: true });
    }
    
    if (identificador == 'itemequipo') {
      this.router.navigate(['/main/itemequipo'], { replaceUrl: true });
    }

    if (identificador == 'equipotercero') {
      this.router.navigate(['/main/equipotercero'], { replaceUrl: true });
    }

    if (identificador == 'agendamientoapp') {
      this.router.navigate(['/main/agendamiento-app/null'], { replaceUrl: true });
    }

    if (identificador == 'calendarioanio') {
      this.router.navigate(['/main/calendarioAnual/null'], { replaceUrl: true });
    }

    if (identificador == 'mapageo') {
      this.router.navigate(['/main/geolocalizacion'], { replaceUrl: true });
    }

    if (identificador == 'archivoscsv') {
      this.router.navigate(['/main/gestor-archivosplanos'], { replaceUrl: true });
    }

    if (identificador == 'Cliente' || identificador == 'Proveedor' || identificador == 'Empleado') {
      this.router.navigate(['/main/terceros/'+identificador], { replaceUrl: true });
    }

    if (identificador == 'fichas') {
      this.router.navigate(['/main/fichas-tecnicas'], { replaceUrl: true });
    }

    if (identificador == 'parametrosConfiguracion') {
      this.router.navigate(['/main/parametros'], { replaceUrl: true });
    }

    if (identificador == 'cotizacion') {
      this.router.navigate(['/main/cotizacion'], { replaceUrl: true });
    }

  }// .ngOnInit() 

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/enrutamientos/enrutamiento/enrutamiento.component.ts